module.exports = __webpack_public_path__ + "img/1.68d8e3f3.jpg";